import { useMemo } from "react";
import { useGetGigQuery, useGetGigsQuery } from "./gigEndpoints";
import { Gig } from "../../entities/gig";
import { Ids } from "../../reducers/rhapsody";

export function useGig(ids?: Ids) {
  const gigQuery = useGetGigQuery(ids, {
    skip: (ids?.id ?? 0) <= 0,
  });
  const gigEntity = gigQuery.data;

  return useMemo(() => {
    const ret: typeof gigQuery & { gig?: Gig | undefined } = {
      ...gigQuery,
    };
    if (gigEntity) ret.gig = new Gig(gigEntity);
    return ret;
  }, [gigEntity]);
}

export function useGigs() {
  const gigQuery = useGetGigsQuery();
  const gigEntitiesMap = gigQuery.data?.entities;

  return useMemo(() => {
    const ret: typeof gigQuery & {
      gigs?: Gig[];
      gigsMap?: { [id: number]: Gig };
    } = {
      ...gigQuery,
      gigs: [],
      gigsMap: {},
    };
    if (gigEntitiesMap) {
      const gigs: Gig[] = [];
      const gigsMap: { [id: number]: Gig } = {};

      for (const key in gigEntitiesMap) {
        if (Object.prototype.hasOwnProperty.call(gigEntitiesMap, key)) {
          const c = gigEntitiesMap[key];
          const gig = new Gig(c);
          gigs.push(gig);
          gigsMap[gig.id] = gig;
        }
      }
      ret.gigs = gigs;
      ret.gigsMap = gigsMap;
    }

    return ret;
  }, [gigEntitiesMap]);
}
